import { ActionReducerMap } from '@ngrx/store';
import { SharedFeatureState } from '../interfaces/shared.interface';
import { advancePreferencesReducer } from './advance-preferences.reducer';
import { staffDetailsReducer } from './staff-details.reducer';
import { callCentreStatusReducer } from './call-centre-status.reducer';
import { complianceSummaryReducer } from './compliance-summary.reducer';
import { nmcNmbiStatusReducer } from './nmc-nmbi-status.reducer';
import { payRatesReducer } from './pay-rates.reducer';
import { welcomePackStatusReducer } from './welcome-pack-status.reducer';
import { firstShiftAppointmentStatusReducer } from './first-shift-appointment-status.reducer';

export const sharedReducers: ActionReducerMap<SharedFeatureState> = {
  staffDetails: staffDetailsReducer,
  callCentreStatus: callCentreStatusReducer,
  complianceSummary: complianceSummaryReducer,
  nmcNmbiStatus: nmcNmbiStatusReducer,
  payRates: payRatesReducer,
  welcomePackStatus: welcomePackStatusReducer,
  firstShiftAppointmentStatus: firstShiftAppointmentStatusReducer,
  advancePreferences: advancePreferencesReducer,
};
